module.exports = __webpack_public_path__ + "static/media/3.1735333f.jpg";